import MicroModal from 'micromodal';

export default function popUpWidget() {
  const widgetName = 'managedPopUp';
  const widgetOpts = managedPopUpOpts;

  // Storage selector-------------
  const sectionTrigger = 'homepage';
  const cookiesTimeStamp = 15;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      const popUpEnable = data.items.length > 0;
      const alwaysShowPopUp = false;

      function closeModal() {
        // Close the popup
        $('.modal__close').on('click keydown', function (event) {
          if (event.type === 'click' || event.key === 'Enter') {
            try {
              MicroModal.close('modal');
              // Remove the modal element from the DOM
              $('#managedPopUp').remove();
            } catch (error) {
              console.error('Error closing modal:', error);
            }
          }
        });
      }

      function initializePopupModal() {
        // FORM LAYOUT-------------
        $('body').append(`
          <div class="modal micromodal-slide" id="modal" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1">
              <div class="modal__container" role="dialog" aria-modal="true">
                <div class="modal__close" aria-label="Close modal">X</div>
                  <main class="modal__content" id="modal-content">
                    <p>Sign up for Text Updates</p>
                    <h2>Stay in the know with updates from the Indiana State Fair</h2>
                  <iframe src="${FULLCLIENTTHEMEPATH}static/hiveForm2026.html?sv=${SITEVERSION}" frameborder="0" id="popupIframe"></iframe>
                </main>
              </div>
            </div>
          </div>
          `);
        MicroModal.init();
        MicroModal.show('modal');
        closeModal();
      }

      if ($('body').hasClass(sectionTrigger) && popUpEnable) {
        // To be triggered on homepage/any other page

        if (alwaysShowPopUp) {
          // if value is true, it will always show the pop up
          initializePopupModal();
        } else {
          // if variable is false

          if (navigator.cookieEnabled) {
            // if cookies are enabled

            if (Cookies.get('modalCookie')) {
              // if there's already a cookie, it wont show the pop up
              $('#managedPopUp').remove();
              return false;
            } else {
              if (localStorage.getItem('modalLocal') == 'true') {
                // if user already set to not show pop up again (checjbox)
                return false;
              } else {
                initializePopupModal();
                Cookies.set('modalCookie', 'modalCookie', { expires: cookiesTimeStamp }); // set the cookie
              }
            }
          } else {
            // if cookies are disabled

            if (sessionStorage.getItem('modalSession')) {
              // get session item, if there's an item, it wont show pop up
              return false;
            } else {
              if (localStorage.getItem('modalLocal') == 'true') {
                // if theres an item, it will check for a local item. if theres an item, it wont show pop up (handled by checkbox)
                return false;
              } else {
                // if theres no item on local, it will show the pop up and set session item
                initializePopupModal();
                sessionStorage.setItem('modalSession', true);
              }
            }
          }
        }
      } else {
        return false;
      }

      // Checkbox setting to remove/add cookie-------------
      $('#removePopUp').on('change', function () {
        if ($(this).is(':checked')) {
          localStorage.setItem('modalLocal', true);
        } else {
          localStorage.setItem('modalLocal', false);
        }
      });
    },

    itemsPerPanel: 1,
    link: [],
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    hasImages: false,
    moreButton: false,
  });
}
